import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../context/AuthContext';

// One line on a thing's own page: when it last changed, who changed it, what
// changed -- and the way into its full History (Phase 6, 1 Oct 2026). Shows
// whether something changed recently without leaving the page.
//
// Director only, like History itself. `refresh` re-reads it after a save.

const MUTED = '#6b7280', TEAL = '#14b8a6', DIM = '#9ca3af';

function ago(iso) {
  const d = new Date(iso);
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const that = new Date(d); that.setHours(0, 0, 0, 0);
  const days = Math.round((today - that) / 86400000);
  if (days === 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 14) return `${days} days ago`;
  return 'on ' + d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export default function LastChanged({ type, id, refresh, style }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [last, setLast] = useState(undefined);
  const director = user && (user.role === 'director' || user.permissionLevel === 'director');

  useEffect(() => {
    if (!director || id == null) return undefined;
    let live = true;
    api.get('/api/v1/history/timeline', { params: { type, id, sources: 'record', limit: 1 } })
      .then(({ data }) => live && setLast(data.entries[0] || null))
      .catch(() => live && setLast(null));
    return () => { live = false; };
  }, [director, type, id, refresh]);

  if (!director || id == null || last === undefined) return null;

  // "Part Tubes - cycle 18 to 16": the part's own page already says which part.
  const what = last && last.summary ? last.summary.replace(/^[^-]*? - /, '') : '';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', fontSize: 12, color: MUTED, ...style }}>
      <i className="fa-solid fa-clock-rotate-left" style={{ fontSize: 11 }} />
      {last ? (
        <span>
          Last changed {ago(last.at)}{last.who ? ` by ${last.who}` : ''}
          {what && <>: <span style={{ color: DIM }}>{what.length > 110 ? what.slice(0, 110) + '…' : what}</span></>}
        </span>
      ) : (
        <span>No changes recorded since History began</span>
      )}
      <span style={{ color: '#2a3040' }}>·</span>
      <button onClick={() => navigate(`/admin/history?type=${type}&id=${encodeURIComponent(id)}`)}
        style={{ background: 'none', border: 'none', padding: 0, color: TEAL, cursor: 'pointer', fontSize: 12 }}>
        History <i className="fa-solid fa-arrow-right" style={{ fontSize: 9 }} />
      </button>
    </div>
  );
}

// The same way in for a whole list: "History" beside a page's title, opening
// History filtered to that kind of thing.
export function HistoryLink({ type, label = 'History', style }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  if (!user || !(user.role === 'director' || user.permissionLevel === 'director')) return null;
  return (
    <button onClick={() => navigate(`/admin/history?type=${type}`)}
      style={{ background: 'transparent', border: '1px solid #2a3040', borderRadius: 8, color: DIM,
               padding: '7px 13px', fontSize: 12.5, cursor: 'pointer', whiteSpace: 'nowrap', ...style }}>
      <i className="fa-solid fa-clock-rotate-left" style={{ fontSize: 11, marginRight: 6 }} />{label}
    </button>
  );
}
